import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Flex, Image, Text } from '@mantine/core';
import classes from './MembersList.module.scss';
import type { Member } from '@/types/member';


type Props = { member: Member };


const TruncatedText: React.FC<{ html?: string; maxLength: number }> = ({ html, maxLength }) => {
    const plain = html ? String(html).replace(/<[^>]*>/g, '').trim() : '';
    const cut = plain.length > maxLength ? `${plain.slice(0, maxLength)}…` : plain;
    return (
        <Text component="p" c="dimmed" className={classes.about}>
            {cut}
        </Text>
    );
};


export const MembersListItem: React.FC<Props> = ({ member }) => {
    return (
        <Flex align="stretch" className={classes.meetThePros__person} gap="md">
            <Box className={classes.photo}>
                <Image src={member.photo} alt={member.name} radius={0} w="100%" />
            </Box>
            <Box className={classes.info}>
                <Link to={`/meet-the-pros/${member.pathname}`} title={member.name} state={member} className={classes.link}>
                    <h3 className={classes.title}>{member.name}</h3>
                    <TruncatedText html={member.about} maxLength={150} />
                </Link>
            </Box>
        </Flex>
    );
};